import { render } from "./DonationProducts.vue?vue&type=template&id=217ef78c&scoped=true&lang=html"
import script from "./DonationProducts.vue?vue&type=script&lang=js"
export * from "./DonationProducts.vue?vue&type=script&lang=js"

import "./DonationProducts.vue?vue&type=style&index=0&id=217ef78c&lang=scss&scoped=true"
import "./DonationProducts.vue?vue&type=style&index=1&id=217ef78c&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217ef78c"]])

export default __exports__